<template>
  <div class="rating-tab shared-index">
    <el-row class="table-title" type="flex" align="center">
      <div class="table-title__left">
        <el-tabs v-model="activeTab" type="card" @tab-click="handleChangeTab">
          <el-tab-pane name="rating">
            <div slot="label">
              Rating
              <span v-if="activeTab === 'rating'">({{ total }})</span>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div>
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          size="small"
          @click="createRating"
        >Thêm</el-button>
        <el-button
          type="primary"
          icon="el-icon-refresh-right"
          size="small"
          @click="handleResetFilters"
        >Làm mới</el-button>
      </div>
    </el-row>

    <!-- Filter Bar -->
    <el-row class="filter-container mb-3 pl-3" :gutter="12" type="flex" align="middle">
      <el-col :span="8">
        <el-select
          v-model="filterPlaceId"
          filterable
          remote
          clearable
          placeholder="Chọn địa điểm để lọc"
          class="w-100"
          :remote-method="searchFilterPlaces"
          :loading="searchingPlaces"
          @change="handleFilterChange"
          @clear="handleFilterChange"
        >
          <el-option
            v-for="p in places"
            :key="p.id"
            :label="p.name"
            :value="p.id"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-select
          v-model="filterOrigin"
          clearable
          placeholder="Chọn nguồn để lọc"
          class="w-100"
          @change="handleFilterChange"
          @clear="handleFilterChange"
        >
          <el-option label="Tất cả nguồn" value=""></el-option>
          <el-option label="Google" value="google">
            <i class="fab fa-google mr-1"></i> Google
          </el-option>
          <el-option label="Booking" value="booking">
            <i class="fas fa-hotel mr-1"></i> Booking
          </el-option>
          <el-option label="Hội đồng đánh giá" value="council">
            <i class="fas fa-award mr-1"></i> Hội đồng đánh giá
          </el-option>
        </el-select>
      </el-col>
    </el-row>

    <list-place-rating
      :loading="callingAPI"
      :data="allRatings"
      @reload="handleReloadAfterDelete"
      @update="updateRating"
    />
    <el-row type="flex" justify="end" class="my-4">
      <el-pagination
        :current-page="page"
        :page-size="limit"
        :total="total"
        background
        layout="total, prev, pager, next"
        @current-change="handleChangePage"
      ></el-pagination>
    </el-row>
    <update-place-rating-popup
      v-if="visibleUpdate"
      :rating-item="selectedRating"
      :visible="visibleUpdate"
      @close="visibleUpdate = false"
      @reload="loadData"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ListPlaceRating from './components/List.vue'
import UpdatePlaceRatingPopup from './components/popup/Update.vue'
import { getTranslation } from '@/utils/filters'
import { listPlaceRatings } from '@/services/place-rating'
import { listPlaces } from '@/services/place'

export default {
  name: 'PlaceRating',
  components: {
    ListPlaceRating,
    UpdatePlaceRatingPopup
  },
  data() {
    return {
      visibleUpdate: false,
      callingAPI: false,
      searchingPlaces: false,
      allRatings: [],
      places: [],
      filterPlaceId: '',
      filterOrigin: '',
      selectedRating: null,
      activeTab: 'rating',
      total: 0,
      limit: 10,
      page: 1
    }
  },
  computed: {
    ...mapGetters(['language']),
    params() {
      const p = {
        page: this.page,
        per_page: this.limit,
        locale: this.language
      }
      if (this.filterPlaceId) {
        p.place_id = this.filterPlaceId
      }
      if (this.filterOrigin) {
        p.origin = this.filterOrigin
      }
      return p
    }
  },
  watch: {
    language: 'loadData'
  },
  beforeMount() {
    this.searchFilterPlaces('')
    this.loadData()
  },
  methods: {
    searchFilterPlaces(query) {
      this.searchingPlaces = true
      listPlaces({
        locale: this.language,
        per_page: 30,
        search_text: query
      }).then((res) => {
        this.places = (res.result || []).map((p) => ({
          id: p.id,
          name: p.name || (getTranslation(p, this.language) ? getTranslation(p, this.language).name : '')
        }))
        this.searchingPlaces = false
      }).catch(() => {
        this.searchingPlaces = false
      })
    },
    loadData() {
      this.callingAPI = true
      this.visibleUpdate = false
      listPlaceRatings(this.params).then((response) => {
        const result = (response && response.result) || (Array.isArray(response) ? response : [])
        this.allRatings = result.map((r) => {
          const translation = getTranslation(r, this.language)
          return {
            ...r,
            name: translation ? translation.name : r.name,
            content: translation ? translation.content : r.content
          }
        })
        this.total = (response && response.total) !== undefined ? response.total : this.allRatings.length
        this.callingAPI = false
      }).catch(() => {
        this.callingAPI = false
      })
    },
    handleFilterChange() {
      this.page = 1
      this.loadData()
    },
    handleResetFilters() {
      this.filterPlaceId = ''
      this.filterOrigin = ''
      this.page = 1
      this.loadData()
    },
    handleChangePage(page) {
      this.page = page
      this.loadData()
    },
    createRating() {
      this.selectedRating = null
      this.visibleUpdate = true
    },
    updateRating(data) {
      this.selectedRating = data
      this.visibleUpdate = true
    },
    handleChangeTab() {
      this.page = 1
      this.loadData()
    },
    handleReloadAfterDelete() {
      if (this.allRatings.length === 1 && this.page > 1) {
        this.page = this.page - 1
      }
      this.loadData()
    }
  }
}
</script>

<style lang="scss" scoped>
.rating-tab {
  .table-title {
    &__left {
      max-width: calc(100% - 200px);
      .el-tabs {
        max-width: 100%;
      }
    }
  }
  .filter-container {
    margin-top: 12px;
    margin-bottom: 12px;
  }
  .w-100 {
    width: 100%;
  }
}
</style>
